// AUTO-GENERATED by scripts/generate-contracts.mjs from the .md sidecar.
// Hand edits will be overwritten on the next run. To customise this
// component's contract (add actions, structured props, custom control
// kinds, glyph pickers), remove this file's auto-generated marker and
// hand-author it — the generator skips files without the marker.

import { z } from "zod";
import { contract } from "@gradeui/contracts";

export const SliderContract = contract({
  name: "Slider",
  description: "A continuous-ish numeric pick — volume, opacity, font size, price-range filters. Use a single-thumb slider for one value, two-thumb for a range. For a small set of discrete options (1-5 stars, sm/md/lg) prefer ToggleGroup. For free-text numeric entry use an Input type=\"number\".",
  import: "@gradeui/ui",
  aliases: ["slider","range slider","range input","volume","opacity slider","scrub","drag value","slider control","value slider","react native slider"],
  composesWith: ["Label (mandatory above)","Row (label + current value display)","Card (settings rows)"],
  styleDefaults: {"Slider":"relative w-full grow overflow-hidden rounded-full"},
  props: {
  "value": {
      schema: z.number().optional(),
      design: "knob",
      description: "controlled value; ALWAYS an array even for a single-thumb slider (`[50]`)",
  },
  "defaultValue": {
      schema: z.number().optional(),
      design: "knob",
      description: "uncontrolled initial; `[20, 80]` for a two-thumb range",
  },
  "onValueChange": {
      schema: z.unknown().optional(),
      design: "event",
  },
  "min": {
      schema: z.number().optional(),
      design: "knob",
  },
  "max": {
      schema: z.number().optional(),
      design: "knob",
  },
  "step": {
      schema: z.number().optional(),
      design: "knob",
  },
  "disabled": {
      schema: z.boolean().optional(),
      design: "knob",
  },
  "orientation": {
      schema: z.enum(["horizontal", "vertical"]).optional(),
      design: "knob",
      default: "horizontal",
  },
  "dir": {
      schema: z.enum(["ltr", "rtl"]).optional(),
      design: "plumbing",
  },
  "inverted": {
      schema: z.boolean().optional(),
      design: "knob",
      description: "flip the visual direction",
  },
  "name": {
      schema: z.string().optional(),
      design: "content",
      description: "form name when posting natively",
  },
  },
});
